import React, { FC } from 'react'
import { CircularProgress } from '@material-ui/core'
import * as Styled from './styled'

export interface RegistrationFormSubmitProps {
  disabled?: boolean
  processing?: boolean
  variant?: 'full-width' | 'contained'
}

export const RegistrationFormSubmit: FC<RegistrationFormSubmitProps> = ({
  children,
  disabled = false,
  processing = false,
  variant = 'full-width',
}) => (
  <Styled.Button
    disabled={disabled}
    type="submit"
    variant={variant}
    data-cy="registration-submit-button"
  >
    {processing ? <CircularProgress size={24} color="inherit" /> : children || 'Create an Account'}
  </Styled.Button>
)
